import { PhaseItemStatus } from './EntityPhase.constants'

export function isPhaseItemStatusFinished(status) {
  return status === PhaseItemStatus.finished
}
